const actions = {
  // LINKS CONFIRM popups ---------------------------------------
  async confirmRemoveLink({dispatch}, id) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: 'Are you sure you want to remove this link?',
      buttons: [
        {
          id: 'confirm',
          name: 'Yes',
          colour: 'red',
          textColour: '#FFF',
          function: () => {
            dispatch('library/delete',id, {root: true})
            dispatch('analytics/deleteContent', null, {root: true})
          }
        },
        {
          id: 'cancel',
          name: 'No',
          textColour: '#FFF',
          function: 'close'
        }
      ]
    }, {root:true})
  },
  async confirmRemoveAllLinks({dispatch}) {
    dispatch('popups/show/confirm',{
      icon: 'error',
      message: 'Are you sure you want to remove all links?',
      buttons: [
        {
          id: 'confirm',
          name: 'Yes',
          colour: 'red',
          textColour: '#FFF',
          function: () => dispatch('library/deleteAll', null, {root:true})
        },
        {
          id: 'cancel',
          name: 'No',
          textColour: '#FFF',
          function: 'close'
        }
      ]
    }, {root: true})
  },
};

export default {
  namespaced: true,
  actions
};
